import {
  CsvExportDefinition,
  formatInverseBoolean,
  formatMillisecondsDate
} from "../../common/csvExport";

interface UserAccessTokenExportRecord {
  id: string | number;
  accessTokenId?: string;
  createdAt?: number;
  disabled?: boolean;
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const userAccessTokenExportDefinition: CsvExportDefinition<UserAccessTokenExportRecord> =
  {
    resource: "UserAccessToken",
    filenameStem: "user-access-tokens",
    id: { header: "userAccessTokenID", source: "id" },
    columns: [
      {
        key: "accessTokenId",
        label: "Access Token ID",
        source: "accessTokenId",
        getValue: (r) => r.accessTokenId
      },
      {
        key: "createdAt",
        label: "Created on",
        source: "createdAt",
        getValue: (r) => formatMillisecondsDate(r.createdAt, dateOptions)
      },
      {
        key: "active",
        label: "Active",
        source: "disabled",
        getValue: (r) => formatInverseBoolean(r.disabled)
      }
    ]
  };
